<div *ngFor="let pk of paymentKeys" class="payBtn-mk">
  <a role="button" (click)="selectPaymentMode(pk)">
    <div class="row bg-white py-3 px-2 border-bottom" [ngClass]="{'active': selectOption==pk}">
      <div class="col-2 my-auto">
        <i class="bi bi-cash-stack fs-5 text-secondary" *ngIf="pk=='POD'"></i>
        <i class="bi bi-truck fs-5 text-secondary" *ngIf="pk=='EMIOD'"></i>
        <i class="bi bi-credit-card fs-5 text-secondary" *ngIf="pk=='RZ'"></i>
        <i class="bi bi-wallet2 fs-5 text-secondary" *ngIf="pk=='CCAVE'"></i>
      </div>

      <div class="col-8 px-0 my-auto">
        <div class="fs-14">{{paymentOptions[pk].title}}</div>
      </div>
    </div>
  </a>
</div>

<table class="table table-bordered">
  <tbody *ngFor="let issuer of emiOptions; let indx = index;" class="payBtn-mk">
    <tr>
      <!-- Accordion Header Row -->
      <td colspan="3" class="accordion-header bg-danger" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#' + issuer.issuerName.replace(' ', '-').toLowerCase()"
          (click)="issuerIndex = indx">
        <a role="button" class="fw-bold text-white">{{ issuer.issuerName }}</a>
      </td>
    </tr>
    <!-- Collapsible Row -->
    <tr [id]="issuer.issuerName.replace(' ', '-').toLowerCase()"
        class="accordion-collapse collapse"
        [class.show]="issuerIndex === indx">
      <td colspan="3">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>EMI Plan</th>
              <th>Interest</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of issuer.listEmiTenure; let i = index"
              (click)="selectEMIOption(option); selectedRowIndex = i"
              [class.active]="selectedRowIndex === i"
              style="cursor: pointer;">
              <td>{{ (option.monthlyInstallment | currency:"INR") + 'x' + option.tenureInMonth + 'm' }}</td>
              <td>{{ option.bankInterestRate / 100 }}%</td>
              <td>{{ (option.loanAmount + option.interestPayToBank) | currency:"INR" }}</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>
<!--<a role="button" (click)="selectEMIOption(emi)">
  <div class="row bg-white py-3 px-2 border-bottom" [ngClass]="{'active': selectOption==pk}">
    <div class="col-8 px-0 my-auto">
      <div class="fs-14">{{emi.issuerName}}</div>
    </div>
  </div>
</a>-->
<div class="mx-2 my-2">
  <button class="border text-white brand-bg border-light fs-14 rounded-2 w-100 py-2" *ngIf="(selectOption == 'RZ' || selectOption == 'CCAVE') && selectOption != null" type="submit" (click)="makeOrder()" [disabled]="makeOrderLoader">
    Make Payment
  </button>
  <button class="border text-white brand-bg border-light fs-14 rounded-2 w-100 py-2" *ngIf="(selectOption == 'EMIOD') && selectOption != null" type="button" (click)="makeOrder()" [disabled]="makeOrderLoader">
    Choose EMI Plan
  </button>
  <button class="border text-white brand-bg border-light fs-14 rounded-2 w-100 py-2" *ngIf="(selectOption == 'POD')" type="submit" [disabled]="makeOrderLoader" (click)="makeOrder()">
    Place Order
  </button>
</div>
